export default function getProvidersFromEditorProps(_ref) {
  var autoformattingProvider = _ref.autoformattingProvider,
    emojiProvider = _ref.emojiProvider,
    mentionProvider = _ref.mentionProvider,
    legacyImageUploadProvider = _ref.legacyImageUploadProvider,
    taskDecisionProvider = _ref.taskDecisionProvider,
    contextIdentifierProvider = _ref.contextIdentifierProvider,
    searchProvider = _ref.searchProvider,
    macroProvider = _ref.macroProvider,
    activityProvider = _ref.activityProvider,
    collabEdit = _ref.collabEdit,
    collabEditProvider = _ref.collabEditProvider,
    presenceProvider = _ref.presenceProvider;
  return {
    emojiProvider: emojiProvider,
    mentionProvider: mentionProvider,
    autoformattingProvider: autoformattingProvider,
    activityProvider: activityProvider,
    imageUploadProvider: legacyImageUploadProvider,
    taskDecisionProvider: taskDecisionProvider,
    contextIdentifierProvider: contextIdentifierProvider,
    searchProvider: searchProvider,
    presenceProvider: presenceProvider,
    macroProvider: macroProvider,
    collabEditProvider: collabEdit !== null && collabEdit !== void 0 && collabEdit.provider ? collabEdit.provider : collabEditProvider
  };
}